// Bu dosya scripts/ilan-paylasim-gorselleri.mjs ile üretilir.
export interface IlanPaylasimGorseli {
  readonly uri: string;
  readonly width: number;
  readonly height: number;
  readonly type: 'image/jpeg';
}

export const ilanPaylasimGorselleri: Readonly<Record<string, IlanPaylasimGorseli>> = {
  '/gorseller/air-jordan.webp': {
    uri: '/paylasim/ilan-5c21d616828387b2.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/akulu-matkap.webp': {
    uri: '/paylasim/ilan-6a1b2ab8e037768b.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/akustik-gitar.webp': {
    uri: '/paylasim/ilan-6325b8f76d073c43.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/antika-radyo.webp': {
    uri: '/paylasim/ilan-2f260b07fd49a586.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/barista-is.webp': {
    uri: '/paylasim/ilan-b8019202437c5f86.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/bebek-arabasi.webp': {
    uri: '/paylasim/ilan-b33ca6aeadf31926.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/dijital-multimetre.webp': {
    uri: '/paylasim/ilan-eb2be354ac62d139.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/espresso-makinesi.webp': {
    uri: '/paylasim/ilan-9183f05410d50685.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/fiat-egea.webp': {
    uri: '/paylasim/ilan-4809a951b963c12e.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/fujifilm.webp': {
    uri: '/paylasim/ilan-6fd530875e678552.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/hobi-satranc.webp': {
    uri: '/paylasim/ilan-deb61795591c66f3.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/honda-civic.webp': {
    uri: '/paylasim/ilan-dd482f3b262c2052.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/iphone-13.webp': {
    uri: '/paylasim/ilan-1d127d0c531ffbac.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/iphone-14-pro-max.webp': {
    uri: '/paylasim/ilan-3cd0d2be9111324a.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/iphone-15-pro.webp': {
    uri: '/paylasim/ilan-2b6d83034ac28520.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/kawasaki.webp': {
    uri: '/paylasim/ilan-d6cccd4b29824384.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/kiralik-daire.webp': {
    uri: '/paylasim/ilan-043a1a5fe66439db.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/kitap-seti.webp': {
    uri: '/paylasim/ilan-66d1013a9ca55d65.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/macbook-air.webp': {
    uri: '/paylasim/ilan-08287c384258f887.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/masa-lambasi.webp': {
    uri: '/paylasim/ilan-649dbf97899e51c6.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/nothing-phone-2.webp': {
    uri: '/paylasim/ilan-1ad2a2cb4a94c7dc.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/ofis-sandalyesi.webp': {
    uri: '/paylasim/ilan-0b95da38e6dc8348.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/pixel-7.webp': {
    uri: '/paylasim/ilan-50e3e2744f8fa361.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/playstation-5.webp': {
    uri: '/paylasim/ilan-cc7d04f1a95a8f4f.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/renault-clio.webp': {
    uri: '/paylasim/ilan-eda2373ae6d7bfdd.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/renault-megane.webp': {
    uri: '/paylasim/ilan-27666716001ac24d.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/saat.webp': {
    uri: '/paylasim/ilan-de5235bddf789234.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/sac-kurutma.webp': {
    uri: '/paylasim/ilan-bfcf8ceb2a44648e.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/samsung-s23-ultra.webp': {
    uri: '/paylasim/ilan-1557ac2b6fb09b48.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/sehir-bisikleti.webp': {
    uri: '/paylasim/ilan-763f6e276b801738.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/tesisat-hizmeti.webp': {
    uri: '/paylasim/ilan-598daab5b8a9b86e.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/toyota-corolla.webp': {
    uri: '/paylasim/ilan-dec1e296e48417cf.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/uclu-kanepe.webp': {
    uri: '/paylasim/ilan-6e92cc1ff3348a01.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/volkswagen-golf.webp': {
    uri: '/paylasim/ilan-c315d56ecb640cbe.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/xiaomi-13t-pro.webp': {
    uri: '/paylasim/ilan-7d03a90887eed731.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
  '/gorseller/yazilim-is.webp': {
    uri: '/paylasim/ilan-a4ed42daa620cb70.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
  },
};
